<template>
    <footer>
        <div class="main-footer container-fluid">
            <div class="logo">
                <img
                    src="@/assets/footer_img_logo.png"
                    alt="台中市政府水利局"
                />
            </div>
            <div class="d-inline-block mx-auto text-left">
                <ul>
                    <li>
                        <img
                            src="@/assets/footer_ic_map.svg"
                            class="mr-1"
                            alt="地址"
                        />地址:
                        <a
                            href="https://goo.gl/maps/pEVYpuaUMp84JMpm6"
                            target="_blank"
                            >420018 臺中市豐原區陽明街36號（陽明大樓）6樓</a
                        >
                    </li>
                    <li>
                        <img
                            src="@/assets/footer_ic_phone.svg"
                            class="mr-1"
                            alt="電話"
                        />電話：<a href="tel:+886-4-22289111">04-22289111</a
                        >(各科室聯絡分機)
                    </li>
                    <li>
                        <img
                            src="@/assets/footer_ic_number.svg"
                            class="mr-1"
                            alt="統依編號"
                        />統一編號：26921656
                    </li>
                </ul>
                <p class="mb-2">
                    辦公時間：上午八點至下午五點半<br />
                    全民監督公共工程施工品質，請撥打通報專線0800-009609
                </p>
                <div class="text-danger">網站客服處理：<a href="mailto: sharonwang@geo.com.tw" class="text-danger">sharonwang@geo.com.tw</a></div>
            </div>
        </div>
        <div class="copyright">
            請使用IE(第9版以上)或Chrome、FireFox、Edge等瀏覽器瀏覽<br />臺中市政府水利局
            版權所有 © 2022
        </div>
    </footer>
</template>

<script>
export default {};
</script>

<style></style>
